module.exports = __webpack_public_path__ + "img/2022.148bef92.jpg";